/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorfallbackdetailstitle3Inputs */



/**
* | output |
* | --- |
* | "Error details" |
*
* @param {Errorfallbackdetailstitle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const errorfallbackdetailstitle3 = /** @type {((inputs?: Errorfallbackdetailstitle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorfallbackdetailstitle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Error details")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detalles del error")
	return /** @type {LocalizedString} */ ("Подробности ошибки")
});
export { errorfallbackdetailstitle3 as "errorFallbackDetailsTitle" }